import React from "react";
import Layout from "../../routes/Layout";

const AboutUs = () => {
  return (
    <Layout>
      <div className="lading-page bg-[#212020] min-h-screen flex flex-col w-full">
        <div className="wrap wrapWidth flex flex-col">
          <h1 className="sm:text-4xl text-2xl font-medium mb-6 text-center text-white">
            About Us
          </h1>
          <div className="bg-white sm:p-8 p-3 rounded-lg shadow-lg">
            <section className="mb-6">
              <h2 className="text-2xl font-normal mb-4">
                Welcome to SmartTract!
              </h2>
              <p className="text-gray-700">
                At SmartTract, we are dedicated to helping individuals enhance
                their personal wellness and fitness through targeted Kegel and
                male enhancement workouts. Our innovative mobile application is
                designed to support you on your journey towards better health
                and improved performance.
              </p>
            </section>
            <section className="mb-6">
              <h2 className="text-2xl font-medium mb-4">Our Mission</h2>
              <p className="text-gray-700">
                Our mission is to provide a comprehensive and user-friendly
                platform that empowers users to take control of their personal
                fitness and wellness goals. We strive to offer effective,
                evidence-based workout routines and tools that promote physical
                health and confidence.
              </p>
            </section>
            <section className="mb-6">
              <h2 className="text-2xl font-medium mb-4">Our Vision</h2>
              <p className="text-gray-700">
                We envision a world where everyone has access to the resources
                they need to improve their physical health and wellbeing. By
                leveraging technology, we aim to break down barriers and make
                specialized fitness routines accessible to all.
              </p>
            </section>
            <section className="mb-6">
              <h2 className="text-2xl font-medium mb-4">What We Offer</h2>
              <ul className="list-disc list-inside text-gray-700">
                <li className="mb-2">
                  <strong>Personalized Workout Plans:</strong> SmartTract
                  provides customized workout plans tailored to your individual
                  needs and goals. Our app takes into account your current
                  fitness level and personal preferences to create a plan that
                  works best for you.
                </li>
                <li className="mb-2">
                  <strong>Progress Tracking:</strong> Track your progress with
                  our intuitive progress tracking features. Monitor your
                  improvements over time, set milestones, and celebrate your
                  achievements as you advance.
                </li>
                <li className="mb-2">
                  <strong>Secure Data Management:</strong> Your privacy is our
                  priority. We offer the option to back up your data securely to
                  our servers, ensuring you never lose your progress even if you
                  change or update your mobile device. All data is encrypted for
                  your peace of mind.
                </li>
                <li className="mb-2">
                  <strong>Expert Resources:</strong> Access a wealth of
                  resources, including expert tips, guides, and tutorials to
                  help you get the most out of your workouts. Our goal is to
                  provide you with the knowledge and tools you need to succeed.
                </li>
              </ul>
            </section>
            <section className="mb-6">
              <h2 className="text-2xl font-medium mb-4">
                Why Choose SmartTract?
              </h2>
              <ul className="list-disc list-inside text-gray-700">
                <li className="mb-2">
                  User-Centric Design: Our app is designed with you in mind,
                  offering a seamless and intuitive user experience.
                </li>
                <li className="mb-2">
                  Evidence-Based Workouts: Our routines are based on scientific
                  research and expert recommendations.
                </li>
                <li className="mb-2">
                  Privacy and Security: We prioritize your privacy and ensure
                  your data is protected with the highest standards of security.
                </li>
              </ul>
            </section>
            <section>
              <h2 className="text-2xl font-medium mb-4">Get Started Today!</h2>
              <p className="text-gray-700">
                Join the SmartTract community and take the first step towards a
                healthier, more confident you. Download our app today and start
                your journey with us!
              </p>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AboutUs;
